export interface CommonPostDownloadScormRequestBody {
  title?: string;
  email: string;
  customLoader?: string;
  params?: Record<string, unknown>;
}

export type GetScormConfigQueryParams = {
  version?: string;
};

export type PostDownloadScormAccessRequestBody = CommonPostDownloadScormRequestBody;

export interface PostDownloadScormProgressRequestBody
  extends CommonPostDownloadScormRequestBody {
  passingPercentage?: string;
}

export interface PostDownloadScormFlexRequestBody
  extends CommonPostDownloadScormRequestBody {
  scoringSlideIds: {
    [key: string]: number;
  };
  completionSlideIds: string[];
}

export interface PostDownloadScormQuestionsRequestBody
  extends CommonPostDownloadScormRequestBody {
  passingPercentage?: string;
  AnswersScore: {
    [key: string]: number;
  };
}

export enum PresetNames {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC',
}

export interface GetSignedUrlRequestBody {
  key: string;
  preset: PresetNames;
}

export interface PostScormConfigRequestBody {
  config: Record<string, unknown>;
}
export type PostScormRequestBody =
  | PostDownloadScormProgressRequestBody
  | PostDownloadScormAccessRequestBody
  | PostDownloadScormFlexRequestBody
  | PostDownloadScormQuestionsRequestBody
  | GetSignedUrlRequestBody
  | PostScormConfigRequestBody;

export enum ResponseStatus {
  Ok = 'ok',
}

export type PostDownloadScormResponse = {
  status: ResponseStatus.Ok;
  key: string;
};

export type PostDownloadScormProgressResponse = PostDownloadScormResponse;
export type PostDownloadScormAccessResponse = PostDownloadScormResponse;
export type PostDownloadScormFlexResponse = PostDownloadScormResponse;
export type PostDownloadScormQuestionsResponse = PostDownloadScormResponse;

export type GetSignedUrlResponse = {
  status: ResponseStatus.Ok;
  signedUrl: string;
};

export type GetScormConfigResponse = {
  status: ResponseStatus.Ok;
  config: Record<string, unknown>;
};

export type PostScormConfigResponse = {
  status: ResponseStatus.Ok;
};
